import { Injectable } from '@angular/core';
import { Capacitor, Plugins } from '@capacitor/core';

// const { Device, FileStorage } = Plugins;

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectionService {
  constructor() {}

  // isDevice(): Promise<boolean> {
  //   return new Promise<boolean>(async resolve => {
  //     const info = await Device.getInfo();
  //     return resolve(info.platform !== 'web');
  //   });
  // }

  // getMacAddress(): Promise<string> {
  //   return new Promise<string>(async (resolve, reject) => {
  //     if (Capacitor.platform !== 'web') {
  //       const macAddress = await FileStorage.getMacAddress();
  //       resolve(macAddress);
  //     } else {
  //       reject(null);
  //     }
  //   });
  // }
}
